import { useMutation, useQueryClient } from '@tanstack/react-query';
import { medicalRecordsApi, type CertificateType } from '@/api';

export function useCreateCertificate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      medicalRecordId?: string;
      patientId: string;
      doctorId: string;
      appointmentId?: string;
      type: CertificateType;
      startDate: string;
      endDate?: string;
      daysOff?: number;
      reason: string;
      observations?: string;
    }) => medicalRecordsApi.createCertificate(data),
    onSuccess: (newCertificate) => {
      queryClient.invalidateQueries({
        queryKey: ['medical-records', 'record', newCertificate.medicalRecordId],
      });
    },
  });
}
